let Emitter = require('tiny-emitter')
let emitter = new Emitter()

export default emitter
